import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { getCurrentUser } from 'aws-amplify/auth';
import { firstValueFrom, Subscription } from 'rxjs';
import { FileService } from 'src/app/services/api/file.service';
import { FunctionsService } from 'src/app/services/api/functions.service';
import { applyCreatedOrdersToServices } from 'src/entities/order';
import { syncServiceTotalFromTickets } from 'src/entities/file/lib/service-table.utils';
import { PreOperationalIncidentsDialogComponent } from 'src/features/file-detail/pre-operational-incidents/ui/pre-operational-incidents-dialog/pre-operational-incidents-dialog.component';
import { buildCreateOrderDialogConfig } from 'src/features/service-order/create-order/ui/create-order/create-order-dialog.config';
import { CreateOrderComponent } from 'src/features/service-order/create-order/ui/create-order/create-order.component';
import { ServicioFormatterService } from './ticketeriaHeleper';

@Component({
  selector: 'app-ticketeria',
  templateUrl: './ticketeria.component.html',
  styleUrls: ['./ticketeria.component.css']
})
export class TicketeriaComponent implements OnInit, OnDestroy {
  loadingGenerarOS: boolean = false;
  // selectedTicket: any = { selectedToOS: [], id: null };
  // selectedTickets: any = { selectedToOS: [] };

  filesWithServices: any = [];
  pendientes: number = 0;
  lastMinute: number = 0;
  loader: boolean = true;
  /** Páginas siguientes en background (como reporte OS). */
  isLoadingMore = false;
  loadedCount = 0;
  dataSource = new MatTableDataSource<any>([]);
  errorMessage: null | string = null;

  interactive = true;
  @Output() preOperationalIncidents = new EventEmitter<any>();

  selectMasivo: boolean = false;

  totalByFileProveedor: number | null = null;
  signoByFileProveedor: string | null = null;

  searchValue: null | string = '';
  selectServicio: null | string = '';
  selectEstado: null | string = '';
  selectFechaGeneracionOS: Date | any = null;
  selectFechaOperacion: Date | null = null;
  misFechasDisponibles = new Set<string>();

  selectPendientes: boolean = false;
  selectLastMinute: boolean = false;

  arrayServicios: any[] = [];

  arrayEstados: any[] = ['Creado', 'En Proceso'];
  adaptedTicketServices: any = [];

  usuario: any;

  displayedColumns: string[] = [
    'ssffproduct',
    'categoriaServicio',
    'fileNumber',
    'displayState',
    'startDateService',
    'providerSnapshot',
    'paxQuantity',
    'tcQuantity',
    'nombreServicio',
    'circuitoTren',
    'varianteFrecuencia',
    'horario',
    'ticket',
    'total',
    'incidentesPreOp',
    'estadoServicioTickets'
  ];
  modelExpand: any[] = [];

  columnsToDisplayWithExpand = ['expand', ...this.displayedColumns];

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort!: MatSort;

  /** Tamaño de página de la tabla (UI, slice local). */
  pageSize: number = 10;
  currentPage = 0;
  totalItems: number = 0;
  private disparadorSub?: Subscription;
  /** Cancela cargas progresivas al refrescar / destroy. */
  private loadGeneration = 0;

  /** Labels UI para estadoServicioTickets (Core). */
  readonly estadoServicioTicketsLabel: Record<string, string> = {
    CREADO: 'Creado',
    EN_PROCESO: 'En Proceso',
    RESERVADO: 'Reservado',
    NUEVA_ADICION: 'Nueva Adición'
  };

  constructor(
    private servicioFormatter: ServicioFormatterService,
    private fileService: FileService,
    public dialog: MatDialog,
    private readonly functions: FunctionsService
  ) {}

  private async loadCurrentUser(): Promise<void> {
    try {
      const user = await getCurrentUser();
      this.usuario = user.signInDetails?.loginId || user.username;
    } catch (error) {
      console.error('Error al obtener usuario actual:', error);
      this.usuario = 'usuario-desconocido';
    }
  }

  ngOnInit(): void {
    this.loadCurrentUser();
    this.reloadTicketData();
    this.disparadorSub = this.functions.disparadorCambios.subscribe(
      (tipo: string) => {
        if (tipo === 'create-order') {
          return;
        }
        this.reloadTicketData({
          silent: tipo === 'reload-programming-silent'
        });
      }
    );
  }

  ngOnDestroy(): void {
    this.loadGeneration += 1;
    this.disparadorSub?.unsubscribe();
  }

  private reloadTicketData(options?: { silent?: boolean }): void {
    const silent = options?.silent === true;
    const generation = ++this.loadGeneration;
    this.isLoadingMore = false;
    this.errorMessage = null;
    this.currentPage = 0;
    if (!silent) {
      this.loader = true;
      this.loadedCount = 0;
      this.modelExpand = [];
      this.adaptedTicketServices = [];
      this.dataSource.data = [];
      this.totalItems = 0;
    }

    void this.loadServiceSummariesProgressively(generation, silent);
  }

  /**
   * Prefetch getTicketeriaServicesPage por lastKey (~1000/página, o corte ~2MB/tiempo).
   * Pinta tras la 1ª página; resto en background. Filtros/sort solo en memoria.
   */
  private async loadServiceSummariesProgressively(
    generation: number,
    silent = false
  ): Promise<void> {
    try {
      await this.fileService.loadTicketeriaServicesPageProgressively(
        (progress) => {
          if (generation !== this.loadGeneration) {
            return;
          }

          const mapped = progress.items.map((item: any) =>
            this.servicioFormatter.formatServicio(item)
          );
          this.adaptedTicketServices =
            silent && progress.pageIndex === 0
              ? mapped
              : [...this.adaptedTicketServices, ...mapped];
          this.loadedCount = progress.loadedCount;

          this.arrayServicios = [
            ...new Set(
              this.adaptedTicketServices.map(
                (serviceTicket: any) => serviceTicket.nombreServicio
              )
            )
          ];

          this.rebuildFechasOsDisponibles();
          this.applyFilterSelect();

          if (progress.pageIndex === 0 && !silent) {
            this.loader = false;
          }
          this.isLoadingMore = progress.hasMore;
        },
        {
          isCancelled: () => generation !== this.loadGeneration
        }
      );

      if (generation === this.loadGeneration) {
        this.loader = false;
        this.isLoadingMore = false;
      }
    } catch (error) {
      if (generation !== this.loadGeneration) {
        return;
      }
      console.error('Error al cargar datos:', error);
      this.errorMessage =
        'No se pudo cargar Ticketería. Intenta actualizar. Si el problema continúa, reinicia con lastKey null.';
      this.adaptedTicketServices = [];
      this.loadedCount = 0;
      this.applyFilterSelect();
    } finally {
      if (generation === this.loadGeneration) {
        this.loader = false;
        this.isLoadingMore = false;
      }
    }
  }

  async toggleExpand(element: any, event?: Event): Promise<void> {
    event?.stopPropagation();

    const index = this.modelExpand.findIndex((e: any) => e === element);
    if (index >= 0) {
      this.modelExpand.splice(index, 1);
      return;
    }

    this.modelExpand.push(element);
    // Cada expand recarga tickets desde Core (no cache de la apertura anterior)
    await this.ensureTicketsLoaded(element, true);
  }

  isExpanded(element: any): boolean {
    return this.modelExpand.some((e: any) => e === element);
  }

  async ensureTicketsLoaded(element: any, force = false): Promise<void> {
    if (!element || (element.ticketsLoaded && !force)) {
      return;
    }

    if (!element.id || !element.idItinerary) {
      element.tickets = [];
      element.ticketsLoaded = true;
      return;
    }

    element.ticketsLoading = true;
    try {
      const res = await firstValueFrom(
        this.fileService.getTicketeriaTicketsByService({
          serviceId: element.serviceId ?? element.id,
          idItinerary: element.idItinerary
        })
      );
      const tickets = res?.getTicketeriaTicketsByService?.tickets ?? [];
      // Preservar checks locales al recargar (si no, selected queda true y Generar OS hace fan-out).
      const prevChecked = new Set(
        (element.tickets || [])
          .filter((t: any) => t?.checked === true)
          .map((t: any) => String(t.id))
      );
      element.tickets = tickets.map((t: any) => ({
        ...t,
        checked: prevChecked.has(String(t.id))
      }));
      element.ticketsLoaded = true;
      syncServiceTotalFromTickets(element);
      element.selected =
        element.tickets.some((t: any) => t.checked === true) || false;
      element.hasInvalidFechaOperacion = element.tickets.some(
        (t: any) => t.hasInvalidFechaOperacion === true
      );
      // Parent summary puede venir stale; al expandir sincronizar con tickets Core
      element.estadoServicioTickets =
        this.servicioFormatter.handleEstadoServicio(element);
      this.rebuildFechasOsDisponibles();
      this.applyFilterSelect();
    } catch (error) {
      console.error('Error al cargar tickets del servicio:', error);
      element.tickets = [];
      element.ticketsLoaded = true;
    } finally {
      element.ticketsLoading = false;
    }
  }

  private rebuildFechasOsDisponibles(): void {
    this.misFechasDisponibles = new Set<string>();
    for (const item of this.adaptedTicketServices ?? []) {
      const fromOrder = item.order?.createdAt;
      if (fromOrder) {
        this.misFechasDisponibles.add(
          new Date(fromOrder).toISOString().split('T')[0]
        );
      }
      for (const ticket of item.tickets ?? []) {
        const fecha = ticket.order?.createdAt ?? null;
        if (fecha) {
          this.misFechasDisponibles.add(
            new Date(fecha).toISOString().split('T')[0]
          );
        }
      }
    }
  }

  showTotal() {
    const dataToFilter: any[] = this.adaptedTicketServices ?? [];
    const data = this.rawDataArrayOnfilters(dataToFilter);

    if (!data.length) return false;

    const allHaveProveedor = data.every(
      (item: any) => item.providerSnapshot?.nombre
    );
    const allHaveFileNumber = data.every((item: any) => item.file?.fileNumber);

    const firstProveedor = data[0].providerSnapshot?.nombre;
    const firstFileNumber = data[0].file?.fileNumber;

    const allSameProveedor = data.every(
      (item: any) => item.providerSnapshot?.nombre === firstProveedor
    );
    const allSameFileNumber = data.every(
      (item: any) => item.file?.fileNumber === firstFileNumber
    );

    const sameData =
      allHaveProveedor &&
      allHaveFileNumber &&
      allSameProveedor &&
      allSameFileNumber &&
      data.length > 1;

    if (sameData) {
      this.totalByFileProveedor = data.reduce(
        (acc: number, item: any) => acc + (item.total || 0),
        0
      );
      this.signoByFileProveedor =
        data.filter((d: any) => d.moneda)?.[0]?.moneda ?? null;
    } else {
      this.totalByFileProveedor = null;
      this.signoByFileProveedor = null;
    }
    return sameData;
  }

  allSameFile() {
    let dataToFilter: any = this.adaptedTicketServices ?? [];
    const data = this.rawDataArrayOnfilters(dataToFilter);

    if (!data.length) return false;

    const firstFileNumber = data[0].file?.fileNumber;
    const allSameFileNumber = data.every(
      (item: any) => item.file?.fileNumber === firstFileNumber
    );
    return allSameFileNumber;
  }

  onSort(sort: Sort) {
    const data = [...this.adaptedTicketServices];

    if (!sort.active || sort.direction === '') {
      this.adaptedTicketServices = data;
      return;
    }

    this.adaptedTicketServices = data.sort((a, b) =>
      this.compareByColumn(a, b, sort.active, sort.direction)
    );

    this.applyFilterSelect();
  }

  compareByColumn(a: any, b: any, column: string, direction: any): number {
    const valueA = this.extractValue(a, column);
    const valueB = this.extractValue(b, column);

    let result = 0;

    if (valueA == null && valueB != null) result = -1;
    else if (valueA != null && valueB == null) result = 1;
    else if (valueA == null && valueB == null) result = 0;
    else if (typeof valueA === 'number' && typeof valueB === 'number') {
      result = valueA - valueB;
    } else if (this.isISODate(valueA) && this.isISODate(valueB)) {
      result = new Date(valueA).getTime() - new Date(valueB).getTime();
    } else {
      result = valueA.toString().localeCompare(valueB.toString(), 'es', {
        numeric: true,
        sensitivity: 'base'
      });
    }

    return direction === 'asc' ? result : -result;
  }

  extractValue(item: any, column: string): any {
    switch (column) {
      case 'providerSnapshot':
        return item.providerSnapshot?.nombre ?? '';
      case 'fileNumber':
        return item.file?.fileNumber ?? '';
      case 'displayState':
        return item.file?.displayState ?? '';
      case 'startDateService':
        return item.startDateService;
      case 'total':
        return Number(item.total);
      case 'paxQuantity':
        return Number(item.paxQuantity);
      case 'tcQuantity':
        return Number(item.tcQuantity);
      case 'estadoServicioTickets':
        return item.estadoServicioTickets ?? '';
      case 'ssffproduct':
        return item.ssffproduct ? 1 : 0;
      default:
        return item[column];
    }
  }

  isISODate(value: any): boolean {
    return (
      typeof value === 'string' &&
      /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value)
    );
  }

  ticketEstadoCreated() {
    let dataToFilter: any = this.adaptedTicketServices ?? [];
    const data = this.rawDataArrayOnfilters(dataToFilter);

    if (!data.length) return false;

    return data.some((item: any) =>
      this.servicioFormatter.isTicketServiceSelectableForOs(item)
    );
  }

  validarFecha = (date: Date | null): boolean => {
    if (!date) return false;
    const iso = date.toISOString().split('T')[0];
    return this.misFechasDisponibles.has(iso);
  };

  blockBotonGenerarOS() {
    let dataToFilter: any = this.adaptedTicketServices ?? [];
    dataToFilter = this.rawDataArrayOnfilters(dataToFilter);

    const hasSelection = dataToFilter?.some((item: any) => {
      if (!this.servicioFormatter.isTicketServiceSelectableForOs(item)) {
        return false;
      }
      if (item.ticketsLoaded && item.tickets?.length) {
        return item.tickets.some(
          (ti: any) => ti.checked === true && !ti.order?.orderId
        );
      }
      return item.selected === true;
    });

    return !hasSelection;
  }

  capitalize(str?: string) {
    if (str && str.trim() !== '')
      return str.charAt(0).toUpperCase() + str.slice(1)?.toLowerCase();
    else return '-';
  }
  vaciarFiltros() {
    this.selectFechaOperacion = null;
    this.selectServicio = '';
    this.selectEstado = '';
    this.selectFechaGeneracionOS = null;
    this.searchValue = '';
  }

  handlePendientes() {
    this.selectPendientes = !this.selectPendientes;
    this.selectLastMinute = false;
    this.vaciarFiltros();
    this.applyFilterSelect(true);
  }
  handleLastMinutes() {
    this.selectLastMinute = !this.selectLastMinute;
    this.selectPendientes = false;
    this.vaciarFiltros();
    this.applyFilterSelect(true);
  }

  onChangeDato(event: {
    id: string;
    idTicket: string;
    changesTickets: any;
    changeGeneral: any;
    hasInvalidFechaOperacion?: any;
  }) {
    const {
      id,
      idTicket,
      changesTickets,
      hasInvalidFechaOperacion,
      changeGeneral
    } = event;

    const targetService = this.adaptedTicketServices.find(
      (item: any) => item.id === id
    );
    const ticket = targetService?.tickets.find((t: any) => t.id === idTicket);
    if (ticket && changesTickets && Object.entries(changesTickets).length > 0)
      Object.assign(ticket, changesTickets);

    if (hasInvalidFechaOperacion != null && targetService) {
      // Highlight padre: cualquier ticket inválido (tras expand) o el flag emitido
      targetService.hasInvalidFechaOperacion =
        hasInvalidFechaOperacion === true ||
        targetService.tickets?.some(
          (t: any) => !t.isDeleted && t.hasInvalidFechaOperacion
        ) === true;
    }

    let changesServices: any = {};
    if (changeGeneral) {
      changesServices = { ...changeGeneral };
      if (
        changeGeneral.newTotalCostoDolares ||
        changeGeneral.newTotalCostoSoles
      )
        changesServices.total =
          this.servicioFormatter.handleCosto({
            ...targetService,
            ...changesServices
          }) ?? 0;
    }
    if (changesServices.paxTickets)
      changesServices.ticket = this.servicioFormatter.handleTipoTicket(
        changesServices.paxTickets
      );
    if (changesTickets.estadoTicket)
      changesServices.estadoServicioTickets =
        this.servicioFormatter.handleEstadoServicio(targetService);
    if (this.servicioFormatter.handleEstadoServicio(targetService) === 'CREADO')
      changesServices.order = null;

    if (Object.entries(changesServices).length > 0)
      Object.assign(targetService, changesServices);

    this.applyFilterSelect();
  }
  onChangeDatosMasivos(event: { ticketsCambiados: any }) {
    const { ticketsCambiados } = event;
    for (const { id, idTicket, changes } of ticketsCambiados) {
      const targetService = this.adaptedTicketServices.find(
        (item: any) => item.id === id
      );
      if (!targetService) {
        console.warn(`No se encontró el servicio con id ${id}`);
        continue;
      }

      const ticket = targetService.tickets.find((t: any) => t.id === idTicket);
      if (!ticket) {
        console.warn(`No se encontró el ticket con id ${idTicket}`);
        continue;
      }

      Object.assign(ticket, { ...changes });

      if (changes.estadoTicket) {
        const newEstado =
          this.servicioFormatter.handleEstadoServicio(targetService);
        const changesServices: any = {
          estadoServicioTickets: newEstado
        };

        const hasTicketOrder = targetService.tickets?.some(
          (t: any) => t.order?.orderNumber || t.order?.orderId
        );
        if (newEstado === 'CREADO' || !hasTicketOrder) {
          changesServices.order = null;
        }

        Object.assign(targetService, changesServices);
      }
    }

    this.applyFilterSelect();
  }

  onTicketsOrderChanged(event: { serviceId: string; serviceIds?: string[] }) {
    const ids = [
      ...new Set(
        (event?.serviceIds?.length
          ? event.serviceIds
          : [event?.serviceId]
        ).filter(Boolean)
      )
    ];
    if (!ids.length) return;
    void this.refreshTicketsAfterOrderChange(ids);
  }

  handleFechaOperacionChange(date: Date | null) {
    this.selectFechaOperacion = date;
    this.applyFilterSelect(true);
  }

  onSelectionChange(event: {
    servicioId: string;
    ticketId: string;
    selected: boolean;
  }) {
    const { servicioId, ticketId, selected } = event;

    const targetServiceRaw = this.adaptedTicketServices.find(
      (item: any) => item.id === servicioId
    );

    const ticketRaw = targetServiceRaw?.tickets.find(
      (t: any) => t.id === ticketId
    );

    if (ticketRaw) {
      ticketRaw.checked = selected;
    }

    if (targetServiceRaw) {
      targetServiceRaw.selected =
        targetServiceRaw.tickets?.some((t: any) => t.checked === true) || false;
    }

    this.applyFilterSelect();

    // Solo sincroniza el checkbox del header; NUNCA dispara selección masiva aquí
    // (antes: [].every() en tickets no cargados → selectMasivo true → seleccionaba todo).
    const dataToFilter = this.rawDataArrayOnfilters(
      this.adaptedTicketServices ?? []
    );
    this.selectMasivo = this.areAllEligibleTicketsSelected(dataToFilter);
  }

  updateCheck() {
    this.selectMasivo = !this.selectMasivo;

    this.changeAlldataRawSelectedState(this.selectMasivo);
  }

  /** Abre el diálogo de incidencias pre-operativas del File del servicio. */
  openPreOperationalIncidents(element: any) {
    const itinerario = { ...(element.file ?? {}), id: element.idItinerary };

    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '700px';
    dialogConfig.maxWidth = '95vw';
    dialogConfig.maxHeight = '90vh';
    dialogConfig.disableClose = true;
    dialogConfig.data = { itinerario };

    const dialogRef = this.dialog.open(
      PreOperationalIncidentsDialogComponent,
      dialogConfig
    );
    dialogRef.afterClosed().subscribe((pendingPreOpIncidents: any) => {
      const value =
        typeof pendingPreOpIncidents === 'number'
          ? pendingPreOpIncidents
          : null;
      for (const service of this.adaptedTicketServices ?? []) {
        if (service.idItinerary === element.idItinerary && service.file) {
          service.file.pendingPreOpIncidents = value;
        }
      }
    });
  }

  /** ¿Todos los servicios elegibles (filtro actual) están seleccionados? */
  private areAllEligibleTicketsSelected(data: any[]): boolean {
    const eligible = (data ?? []).filter((item: any) =>
      this.servicioFormatter.isTicketServiceSelectableForOs(item)
    );
    if (!eligible.length) return false;

    return eligible.every((item: any) => {
      if (item.ticketsLoaded && item.tickets?.length) {
        const creados = item.tickets.filter((ti: any) => {
          const estado = String(ti.estadoTicket ?? '')
            .toUpperCase()
            .replace(/\s+/g, '_');
          return estado === 'CREADO' || estado === 'CREATED';
        });
        if (!creados.length) return true;
        return creados.every((ti: any) => ti.checked === true);
      }
      return item.selected === true;
    });
  }

  changeAlldataRawSelectedState(value: boolean) {
    const filtros = this.instanciarFiltros();

    for (const item of this.adaptedTicketServices) {
      if (this.rawItemOnFilters(item, filtros)) {
        const canSelect =
          this.servicioFormatter.isTicketServiceSelectableForOs(item);
        item.selected = value && canSelect;

        if (item.ticketsLoaded && item.tickets?.length) {
          item.tickets = item.tickets.map((ticket: any) => {
            const estado = String(ticket.estadoTicket ?? '')
              .toUpperCase()
              .replace(/\s+/g, '_');
            const isCreado = estado === 'CREADO' || estado === 'CREATED';
            return {
              ...ticket,
              checked: isCreado ? value && canSelect : false
            };
          });
        }
      }
    }
  }

  generarOS() {
    let dataToFilter: any[] = this.adaptedTicketServices ?? [];
    dataToFilter = this.rawDataArrayOnfilters(dataToFilter);

    // Tickets cargados + checked → ticketIds (nunca fan-out silencioso).
    // Sin expand / sin tickets cargados + padre selected → fan-out.
    const items = dataToFilter
      .filter((item: any) =>
        this.servicioFormatter.isTicketServiceSelectableForOs(item)
      )
      .map((item: any) => {
        const serviceId = String(item.id || '');
        if (!serviceId) return null;

        if (item.ticketsLoaded && item.tickets?.length) {
          const checkedTicketIds = (item.tickets || [])
            .filter(
              (ti: any) =>
                ti.checked === true &&
                !ti.order?.orderId &&
                String(ti.id || '').trim()
            )
            .map((ti: any) => String(ti.id));

          if (!checkedTicketIds.length) {
            return null;
          }
          return { serviceId, ticketIds: checkedTicketIds };
        }

        if (item.selected === true) {
          return { serviceId };
        }
        return null;
      })
      .filter(Boolean) as Array<{ serviceId: string; ticketIds?: string[] }>;

    if (!items.length) return;

    const serviceIds = items.map((item) => item.serviceId);

    const operationDates = items.map((item) => {
      const row = dataToFilter.find(
        (r: any) => String(r?.id || '') === item.serviceId
      );
      return row?.startDateService ?? row?.serviceDate ?? null;
    });

    const dialogRef = this.dialog.open(
      CreateOrderComponent,
      buildCreateOrderDialogConfig({
        items,
        operationDates,
        contextLabel: 'Ticketería'
      })
    );
    dialogRef.afterClosed().subscribe(async (result: any) => {
      if (!result) {
        return;
      }

      if (result.shouldRefresh) {
        this.reloadTicketData();
        return;
      }

      if (result.success) {
        const createdOrders = result.result?.createdOrders ?? [];
        applyCreatedOrdersToServices(
          this.adaptedTicketServices,
          createdOrders,
          'id',
          result.submittedInput
        );
        const touchedIds = [
          ...new Set([
            ...serviceIds,
            ...createdOrders.flatMap((o: any) =>
              (o?.serviceIds ?? []).map((id: any) => String(id))
            )
          ])
        ];
        await this.refreshTicketsAfterOrderChange(touchedIds);
      }
    });
  }

  /**
   * Tras crear/borrar OS: recarga tickets Core, actualiza estado del padre
   * y mantiene el expand abierto en la fila afectada.
   */
  private async refreshTicketsAfterOrderChange(
    serviceIds: string[]
  ): Promise<void> {
    const expandedIds = this.modelExpand
      .map((e: any) => e?.id ?? e?.serviceId ?? null)
      .filter((id: any) => id != null);

    for (const serviceId of serviceIds) {
      const row = this.adaptedTicketServices.find(
        (s: any) => s.id === serviceId || s.serviceId === serviceId
      );
      if (!row) continue;

      row.selected = false;
      row.ticketsLoaded = false;
      row.tickets = [];

      const keepExpanded =
        expandedIds.includes(row.id) || expandedIds.includes(row.serviceId);

      if (keepExpanded) {
        await this.ensureTicketsLoaded(row);
      }

      if (row.ticketsLoaded && row.tickets?.length) {
        row.estadoServicioTickets =
          this.servicioFormatter.handleEstadoServicio(row);
        row.hasInvalidFechaOperacion = row.tickets.some(
          (t: any) => t.hasInvalidFechaOperacion === true
        );
        // Listado Ticketería: order del padre no se pinta; limpiar si ningún ticket tiene OS
        if (!row.tickets.some((t: any) => t.order != null)) {
          row.order = null;
        }
      } else if (row.hasOrderedTickets) {
        // Padres tocados no expandidos: no dejar estado CREADO stale.
        row.estadoServicioTickets = 'EN_PROCESO';
      }
    }

    this.rebuildFechasOsDisponibles();
    this.applyFilterSelect();
  }

  resetFechaPago(att: string) {
    if (att === 'selectFechaOperacion') this.selectFechaOperacion = null;
    else this.selectFechaGeneracionOS = null;
    this.applyFilterSelect(true);
  }

  handleContadorPendientes(data: any[] = []) {
    this.pendientes =
      data.filter((item: any) => this.isTicketPendiente(item))?.length ?? 0;
  }

  handleContadorLastMinutes(data: any[] = []) {
    this.lastMinute =
      data.filter((item: any) => this.isFileLastMinute(item))?.length ?? 0;
  }

  /** Pendiente = estadoServicioTickets CREADO (no EN_PROCESO / RESERVADO / etc.). */
  private isTicketPendiente(item: any): boolean {
    const estado = String(item?.estadoServicioTickets ?? '')
      .trim()
      .toUpperCase();
    return estado === 'CREADO' || estado === 'CREATED';
  }

  /**
   * Last Minute según file.displayState (Core).
   * Normaliza casing / guiones: "Last Minute", "LAST_MINUTE", "LAST MINUTE".
   */
  private isFileLastMinute(item: any): boolean {
    const state = String(item?.file?.displayState ?? '')
      .trim()
      .toUpperCase()
      .replace(/_/g, ' ')
      .replace(/\s+/g, ' ');
    return state === 'LAST MINUTE';
  }

  /** Valores indexables para búsqueda (incluye anidados paint-ready). */
  private collectSearchableValues(item: any): string[] {
    const push = (values: string[], val: unknown) => {
      if (val == null) return;
      if (typeof val === 'string' || typeof val === 'number') {
        values.push(String(val).toLowerCase());
      }
    };

    const allValues: string[] = [];

    for (const val of Object.values(item ?? {})) {
      push(allValues, val);
    }

    // Nested Core shape: file / proveedor / order no son strings top-level
    push(allValues, item?.file?.fileNumber);
    push(allValues, item?.file?.displayState);
    push(allValues, item?.file?.fileExtend);
    push(allValues, item?.providerSnapshot?.nombre);
    push(allValues, item?.providerSnapshot?.razonSocial);
    push(allValues, item?.providerSnapshot?.correoReserva);
    push(allValues, item?.order?.orderNumber);
    push(allValues, item?.order?.orderStatus);

    for (const ticket of item?.tickets ?? []) {
      for (const val of Object.values(ticket ?? {})) {
        push(allValues, val);
      }
      push(allValues, ticket?.order?.orderNumber);
      push(allValues, ticket?.order?.orderStatus);
    }

    return allValues;
  }

  rawItemOnFilters(item: any, filtros: any) {
    const {
      hasSearch,
      terms,
      hasPendientes,
      hasLastMinute,
      hasFechaOperacion,
      hasServicio,
      hasEstado,
      selectedOperacionDate,
      selectedOSDate,
      hasFechaOS
    } = filtros;

    if (hasSearch) {
      const allValues = this.collectSearchableValues(item);
      const match = terms?.every((term: any) =>
        allValues.some((v) => v.includes(term))
      );

      if (!match) return false;
    }

    if (hasPendientes && !this.isTicketPendiente(item)) {
      return false;
    }

    if (hasLastMinute && !this.isFileLastMinute(item)) {
      return false;
    }

    if (hasFechaOperacion) {
      const parts = /^(\d{4})-(\d{2})/.exec(
        (item.startDateService ?? '').trim()
      );
      const itemYear = parts
        ? Number(parts[1])
        : new Date(item.startDateService).getUTCFullYear();
      const itemMonth = parts
        ? Number(parts[2]) - 1
        : new Date(item.startDateService).getUTCMonth();
      if (
        itemMonth !== selectedOperacionDate!.getMonth() ||
        itemYear !== selectedOperacionDate!.getFullYear()
      ) {
        return false;
      }
    }

    if (hasServicio) {
      const itemService = item.nombreServicio?.toLowerCase() ?? null;
      const selectedService =
        this.selectServicio?.toLowerCase() === 'no asignado'
          ? null
          : this.selectServicio?.toLowerCase();

      if (itemService !== selectedService) return false;
    }

    if (hasEstado) {
      const itemEstadoLabel =
        this.estadoServicioTicketsLabel[
          String(item.estadoServicioTickets ?? '').toUpperCase()
        ]?.toLowerCase() ?? null;
      const selectedEstado =
        this.selectEstado?.toLowerCase() === 'no asignado'
          ? null
          : this.selectEstado?.toLowerCase();

      if (itemEstadoLabel !== selectedEstado) return false;
    }

    let hasOSDateMatch = false;
    const orderCreatedAt = item.order?.createdAt;
    if (orderCreatedAt) {
      const iso = new Date(orderCreatedAt).toISOString().split('T')[0];
      this.misFechasDisponibles.add(iso);
      if (hasFechaOS && iso === selectedOSDate) {
        hasOSDateMatch = true;
      }
    }

    for (const ticket of item.tickets ?? []) {
      const fechaOs = ticket.order?.createdAt ?? orderCreatedAt;
      if (fechaOs) {
        const iso = new Date(fechaOs).toISOString().split('T')[0];
        this.misFechasDisponibles.add(iso);

        if (hasFechaOS && iso === selectedOSDate) {
          hasOSDateMatch = true;
        }
      }
    }

    if (hasFechaOS && !hasOSDateMatch) return false;

    return true;
  }

  instanciarFiltros() {
    const hasSearch = !!this.searchValue?.trim();
    const terms = hasSearch
      ? this.searchValue?.toLowerCase().split(' ').filter(Boolean)
      : [];

    const hasPendientes = this.selectPendientes;
    const hasLastMinute = this.selectLastMinute;
    const hasFechaOperacion = !!this.selectFechaOperacion;
    const hasServicio = !!this.selectServicio;
    const hasEstado = !!this.selectEstado;
    const hasFechaOS = !!this.selectFechaGeneracionOS;

    const selectedOperacionDate = hasFechaOperacion
      ? new Date(this.selectFechaOperacion!)
      : null;

    const selectedOSDate = hasFechaOS
      ? new Date(this.selectFechaGeneracionOS!).toISOString().split('T')[0]
      : null;

    return {
      hasSearch,
      terms,
      hasPendientes,
      hasLastMinute,
      hasFechaOperacion,
      hasServicio,
      hasEstado,
      selectedOperacionDate,
      selectedOSDate,
      hasFechaOS
    };
  }

  rawDataArrayOnfilters(dataToFilter: any[]) {
    const filtros = this.instanciarFiltros();
    return dataToFilter.filter((item: any) =>
      this.rawItemOnFilters(item, filtros)
    );
  }

  applyFilterSelect(resetSelection = false) {
    if (resetSelection && this.selectMasivo === true) {
      this.selectMasivo = false;
      this.changeAlldataRawSelectedState(false);
    }

    this.handleContadorPendientes(this.adaptedTicketServices);
    this.handleContadorLastMinutes(this.adaptedTicketServices);

    let dataToFilter: any[] = this.adaptedTicketServices ?? [];

    dataToFilter = this.rawDataArrayOnfilters(dataToFilter);

    const start = this.currentPage * this.pageSize;
    const end = start + this.pageSize;
    this.totalItems = dataToFilter?.length;

    this.dataSource.data = dataToFilter.slice(start, end);
    if (this.paginator) {
      this.paginator.length = this.totalItems;
    }
  }

  onPageChange(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.applyFilterSelect();
  }

  hasInvalidTickets(element: any): boolean {
    if (element.hasInvalidFechaOperacion) {
      return true;
    }
    // Tras expand: Core manda hasInvalidFechaOperacion en cada ticket
    return (
      element.tickets?.some((t: any) => t.hasInvalidFechaOperacion === true) ||
      false
    );
  }
}
